export default __webpack_public_path__ + "static/segments-681aa0be0555bbef0f3999abd1643fb9.png";